// pages/Contact.jsx

import React from 'react';
import Navbar from '../components/Navbar';


export default function Contact() {
  return (
    <>
    <Navbar />
    <div className="min-h-screen bg-gradient-to-br from-pink-50 to-purple-50 flex items-center justify-center px-4 py-10">
      <div className="bg-white p-8 rounded-xl shadow-lg max-w-xl w-full text-center">
        <h1 className="text-3xl font-bold text-purple-700 mb-4">Contact Us</h1>
        <p className="text-gray-600 mb-6">
          We're here to help you become a Pro Brainy! Reach out to us on WhatsApp or email — and we'll guide you through the next steps.
        </p>

        <div className="mb-6">
          <p className="font-semibold text-purple-600">📞 WhatsApp:</p>
          <a
            href="https://wa.me/9894446560"
            className="text-blue-600 underline hover:text-blue-800"
            target="_blank"
            rel="noopener noreferrer"
          >
            +91 98944 46560
          </a>
        </div>

        <div>
          <p className="font-semibold text-purple-600">📧 Email:</p>
          <a
            href="mailto:support@brainybuddy.in"
            className="text-blue-600 underline hover:text-blue-800"
          >
            support@brainybuddy.in
          </a>
        </div>
      </div>
    </div>
    </>
  );
}
